import i18n from "../../services/localization-service/i18n";
import { ActionMenuItem, BaseActions } from "../action-menu/ActionMenuItem";
import { IEditTierDTO } from "../../services/alarm-scheme-data-service/Models";
import { AddIcon } from "../action-menu/ActionMenuIcons";

export type AlarmSchemeNotificationListType =  {
    notificationListID: number;
    notificationListName: string;

    organizationID: number;
    organizationName: string;
}

export type AlarmSchemeScheduledNotificationType = {
    scheduleID: number;
    scheduleName: string;

    organizationID: number;
    organizationName: string;

    notifications: AlarmSchemeNotificationListType[];
}

export type AlarmSchemeTierType = {

    notifications: AlarmSchemeNotificationListType[];
    useScheduledNotifications: boolean;

    scheduledNotifications: AlarmSchemeScheduledNotificationType[];
    
} & IEditTierDTO


export enum TierActions  {
    Add = 'add',
    Edit = 'edit',
    Delete = 'delete'
}

export type TierActionItem = {
    action: TierActions | BaseActions | string
} & ActionMenuItem;

export const tierActionItems: TierActionItem[] = [{
    label: i18n.t("actions.newTier"),
    icon: AddIcon,
    action: TierActions.Add,
    order: 0
}];




